import React from "react";
import { Loader2 } from "lucide-react";
import "../styles/AttendanceLoader.css";

function AttendanceLoader({ message = "Processing Attendance Data...", subtitle = "Please wait a moment while we process your request." }) {
  return (
    <div className="attendance-loader-card">
      <div className="loader-spinner-wrapper">
        <div className="loader-ring"></div>
        <Loader2 className="loader-icon-spin" size={28} />
      </div>
      <h3 className="loader-title">{message}</h3>
      <p className="loader-subtitle">{subtitle}</p>
    </div>
  );
}

export default AttendanceLoader;
